import { defineComponent as _defineComponent } from 'vue'
import Vue, {
  computed, PropType, ref, watch,
} from 'vue';
import {
  dateStringFromDate8601, timeStringFromDate, dateFromDateTimeString8601, isDateToday,
  isDateSameIgnoringTime,
} from '@/services/time-utils';
import { VDatePicker, VMenu } from 'vuetify/lib';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimePickerField',
  props: {
  value: { type: Object as PropType<Date | null>, required: true },
  formatFn: { type: Function as PropType<((d: Date) => string | null)>, required: false, default: undefined },
  disabled: { type: Boolean, required: false, default: false },
  label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  type: { type: String, required: false, default: 'date' },
  dense: { type: Boolean, required: false, default: false },
  hideDetails: { type: Boolean, required: false, default: false },
  outlined: { type: Boolean, required: false, default: false },
  clearable: { type: Boolean, required: false, default: false },
  errorMessages: { type: Array, required: false, default: null },
  contentClass: { type: String, required: false, default: '' },
  minDate: { type: Object as PropType<Date|undefined>, required: false, default: undefined },
  maxDate: { type: Object as PropType<Date|undefined>, required: false, default: undefined },
  allowedMinutes: { type: Array, required: false, default: () => [0, 15, 30, 45] as Array<Number> },
  defaultTime: { type: String, required: false, default: undefined },
},
  emits: ["input", "click:append-outer"],
  setup(__props, { emit }: { emit: ({(e: 'input', value: Date | null): void, (e: 'click:append-outer', evt: any | null): void}), expose: any, slots: any, attrs: any }) {

const props = __props;




const date = ref(dateStringFromDate8601(props.value ?? undefined));
const time = ref(timeStringFromDate(props.value));
const menu = ref(false);

const menuRef = ref(undefined as undefined | Vue & {save: (val: any) => void});
const timePickerRef = ref(undefined as undefined | Vue & {selectingHour: boolean});

const dateTimeStr = computed(() => (`${date.value} ${time.value ?? props.defaultTime ?? ''}`));

const formattedDate = computed(
  () => (!props.formatFn ? dateTimeStr.value : props.formatFn(dateFromDateTimeString8601(dateTimeStr.value)!)),
);

const dDate = computed(() => dateFromDateTimeString8601(dateTimeStr.value));

watch(() => props.value, () => {
  date.value = dateStringFromDate8601(props.value ?? undefined)!;
  time.value = timeStringFromDate(props.value)!;
});

const updateValue = () => {
  if (timePickerRef.value) { timePickerRef.value.selectingHour = true; }
  emit('input', dateFromDateTimeString8601(dateTimeStr.value));
};

const clear = () => {
  date.value = null;
  time.value = null;
  updateValue();
};


return { __sfc: true,props, emit, date, time, menu, menuRef, timePickerRef, dateTimeStr, formattedDate, dDate, updateValue, clear, dateStringFromDate8601, timeStringFromDate, isDateToday, isDateSameIgnoringTime, VDatePicker, VMenu }
}

})